import { Autocomplete, Chip, TextField, Box, ListItemIcon } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import { ILegalClientGroup } from "../Interfaces/ILegalClientGroup";

interface Props {
  value: ILegalClientGroup[];
  options: ILegalClientGroup[];
  onChange: (newValue: ILegalClientGroup[]) => void;
  label?: string;
}

export const LegalClientGroupSelector = ({
                                           value,
                                           options,
                                           onChange,
                                           label = "Gruppen",
                                         }: Props) => {
  const first = value[0];
  const extraCount = Math.max(0, value.length - 1);

  return (
    <Autocomplete<ILegalClientGroup, true, false, false>
      multiple
      size="small"
      fullWidth
      disableCloseOnSelect
      options={options}
      value={value}
      isOptionEqualToValue={(o, v) => o.idLegalClientGroup === v.idLegalClientGroup}
      onChange={(_, newValue) => onChange(newValue)}
      getOptionLabel={(opt) => opt.Name}
      renderTags={() => null}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Gruppen auswählen"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                {first && (
                  <Chip
                    label={first.Name}
                    size="small"
                    sx={{
                      backgroundColor: first.ColorHex,
                      color: "white",
                    }}
                  />
                )}

                {extraCount > 0 && (
                  <Chip
                    label={`+${extraCount}`}
                    size="small"
                    clickable
                    onClick={() => {
                      const ref = params.InputProps.ref;

                      if (ref && typeof ref === "object" && "current" in ref && ref.current) {
                        ref.current.focus();
                      } else {
                        const el = document.querySelector(`#${params.id}`) as HTMLElement | null;
                        el?.focus();
                      }
                    }}

                  />
                )}

                {params.InputProps.endAdornment}
              </Box>
            ),
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.idLegalClientGroup}>
          <ListItemIcon sx={{ minWidth: 28 }}>
            <CircleIcon sx={{ color: option.ColorHex, fontSize: 14 }} />
          </ListItemIcon>
          {option.Name}
        </li>
      )}
    />
  );
};
